import { render, staticRenderFns } from "./UngroupedList.vue?vue&type=template&id=4a413e09"
import script from "./UngroupedList.vue?vue&type=script&lang=js"
export * from "./UngroupedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports